module.exports = __webpack_public_path__ + "static/10-70f4a254fac7e5671f755ca10f2ebcec.jpeg";